import React from "react";
import tw, { styled } from "twin.macro";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import Marquee from "react-marquee-slider";

const Section = tw.section`flex flex-col w-full relative px-4 md:px-12`;

const Blue = styled.div(({ inner }) => [
  tw`absolute bottom-0 left-0 w-full h-[35%] bg-dark z-behind`,
  inner && tw`h-[100%]`,
]);

const Slick = styled(Slider)`
  ${tw`w-full bg-white`}

  .slick-list {
    ${tw``}
  }

  .slick-track {
    ${tw`flex! py-4 items-stretch!`}
  }
  .slick-slide {
    ${tw`relative h-auto`}

    & > div {
      ${tw`w-full h-full flex items-center justify-center relative`}
    }

    .gatsby-image-wrapper {
      ${tw`[img]:object-contain!`}
    }
  }
`;

const Awards = ({ inner, ...rest }) => {
  const { awards } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsAwards {
          firmAwards {
            awards {
              award: singleAward {
                ...GatsbyImage_SVG
              }
            }
          }
        }
      }
    }
  `).wp.acfOptionsAwards.firmAwards;

  const settings = {
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 5,
    speed: 700,
    infinite: true,
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: (i) => <div></div>,
  };

  const listAwards = awards.map(({ award }, i) => {
    return (
      <GatsbyImage
        key={i}
        image={getImage(award.localFile)}
        alt={award.altText}
      />
    );
  });
  return (
    <Section {...rest}>
      <Slick {...settings}>{listAwards}</Slick>
      <Blue inner={inner} />
    </Section>
  );
};

export default Awards;
